(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AmazonStatementDialogController', AmazonStatementDialogController);

    AmazonStatementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AmazonStatement', 'GcSystem', 'CampagnaAmazon'];

    function AmazonStatementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AmazonStatement, GcSystem, CampagnaAmazon) {
        var vm = this;

        vm.amazonStatement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gcsystems = GcSystem.query();
        vm.campagnaamazons = CampagnaAmazon.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.amazonStatement.id !== null) {
                AmazonStatement.update(vm.amazonStatement, onSaveSuccess, onSaveError);
            } else {
                AmazonStatement.save(vm.amazonStatement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:amazonStatementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.gcExpirationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
